import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext";

const LandingPage = () => {
  const navigate = useNavigate();
  const { familyName } = useAuth();

  const GuardianButton = async (e) => {
    e.preventDefault();
    navigate("/grownups");
  };
  const KidsButton = async (e) => {
    e.preventDefault();
    navigate("/selectchild");
  };

  return (
    <>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Center horizontally
        justifyContent: "center", // Center vertically
        textAlign: "center", // Center the text
        height: "70%", // Ensure it takes full height of its parent
        margin: 0,

      }}>
        <h1 style={{ fontWeight: "800" }}>Welcome {familyName?.toLowerCase().includes(" fam") ? familyName : `${familyName} Family`}!</h1>
        <h2 style={{ fontWeight: "500" }}>Who's Learning With Us Today?</h2>
        <div className="landingPageContainer">
          <button onClick={GuardianButton} className="landingPageButton">
            <span className="mr-2">&#8592;</span> Grown Ups
          </button>
          <button onClick={KidsButton} className="landingPageButton">
            Kids <span className="ml-2">&#8594;</span>
          </button>
        </div>
      </div >
    </>
  );
};

export default LandingPage;
